var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form Control Element"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Outer Rectangle",
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 3.25,
    fill: "white",
    stroke: "#DFE5EB",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSvg);
export default __webpack_public_path__ + "static/media/CheckboxSvg.828d961992a527d6de0742f169091ee0.svg";
export { ForwardRef as ReactComponent };